import { TOMATO_RED } from '@propertypal/shared/src/styles/theme';
import { PINK } from '@propertypal/shared/src/styles/theme/propertynews';
import platform from '@propertypal/shared/src/utils/platform';
import styled, { css, keyframes } from 'styled-components';

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateX(16px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const ToastList = styled.div`
  position: fixed;
  top: 16px;
  right: 16px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 350px;
  max-width: calc(100% - 32px);
`;

export const ToastItem = styled.div<{ $closing?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: ${() => platform.select(TOMATO_RED, PINK)};
  color: #fff;
  border-radius: 6px;
  padding: 14px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  animation: ${slideIn} 200ms ease-out;
  transition:
    opacity 200ms ease-in,
    transform 200ms ease-in;

  ${({ $closing }) =>
    $closing &&
    css`
      opacity: 0;
      transform: translateX(16px);
    `}
`;

export const ToastIcon = styled.div`
  flex-shrink: 0;
  margin-top: 2px;
`;

export const ToastContent = styled.div`
  flex: 1;
`;

export const CloseButton = styled.button`
  flex-shrink: 0;
  background: none;
  border: none;
  padding: 2px;
  cursor: pointer;
  opacity: 0.8;

  &:hover {
    opacity: 1;
  }
`;

export const ToastTitle = styled.b`
  display: block;
  font-size: 18px;
`;

export const ToastMessage = styled.span`
  display: block;
  margin-top: 3px;
`;
